<template>
    <base-layout>
        <template v-slot:header>
            <div
                class="index-bg-img"
                v-if="indexBgImg"
            >
                <img
                    :src="indexBgImg"
                    alt
                    srcset
                >
            </div>
        </template>
        <template v-slot:main>
            <router-view></router-view>
        </template>
    </base-layout>
</template>

<script>
import BaseLayout from "../layouts/BaseLayout";
export default {
  components: {
    BaseLayout
  },
  data() {
    return {
      indexBgImg: "",
      Imgs: {
        "/past-view":
          "http://www.yibaicdn.com/7353e760-810c-11e9-a0be-8359aed93c78.jpg",
        "/about-us":
          "http://www.yibaicdn.com/3b0905b0-814e-11e9-a0be-8359aed93c78.jpeg",
        "/about-pulpit":
          "http://www.yibaicdn.com/1057fab0-810d-11e9-a0be-8359aed93c78.jpg",
        "/inspirational-pulpit":
          "http://www.yibaicdn.com/cc37bba0-8142-11e9-af1d-bdcd5ded6f5c.png",
        "/all-guest":
          "http://www.yibaicdn.com/cc37bba0-8142-11e9-af1d-bdcd5ded6f5c.png"
      }
    };
  },
  created() {
    this.indexBgImg = this.Imgs[this.$route.path];
  },
  updated() {},
  watch: {
    $route(to, from) {
      this.indexBgImg = this.Imgs[to.path];
    }
  }
};
</script>

<style lang="less" scoped>
.index-bg-img {
  // min-height: 580px;
}
</style>